import React from "react";
import "./Projects.css";
import projec1 from "../../../images/projects/project3.png";
import project5 from "../../../images/projects/project8.png";
import ProjectsCard from "../ProjectsCard/ProjectsCard";

const projects = [
  {
    id: 1,
    image: project5,
    title: "Fitness",
    desc: "This is a React.js project with attractive UI. This project is related to health and fitness. I used react slider, infinity slider in this project. In this website user can get necessary information about the Institute.",
    liveURL: "https://fitney415.netlify.app/",
    codeURL: "https://github.com/jubayerweb/",
    tech: [
      { id: 1, data: "React" },
      { id: 2, data: "React Router" },
      { id: 3, data: "React Slider" },
      { id: 4, data: "Slider Tab" },
      { id: 5, data: "Infinite Slider" },
      { id: 6, data: "JavaScript" },
      { id: 7, data: "CSS" },
      { id: 7, data: "Bootstrap" },
    ],
  },
  {
    id: 2,
    image: projec1,
    title: "Modern Solution",
    desc: "This is a MERN stack web application, where user can get modern solutions for growing their start up business. Admin can add services, update products and delete products from Admin panel. Users can see their orders. Also, they can give reviews.",
    liveURL: "https://esolution23.netlify.app/",
    codeURL: "https://github.com/jubayerweb/esolution",
    tech: [
      { id: 1, data: "React" },
      { id: 2, data: "Router" },
      { id: 3, data: "NodeJS" },
      { id: 4, data: "MongoDB" },
      { id: 5, data: "Express" },
      { id: 6, data: "Firebase" },
      { id: 7, data: "StripeJS" },
    ],
  },
  // {
  //   id: 3,
  //   image: projec5,
  //   title: "Covid-19 Tracker",
  //   desc: "The project is going to fetch the live data from the API using Async/Await syntax. In this projects, I also use React Hooks. So you can see the Current Info of the Covid Situations. Also you can see any individual country covid situations.",
  //   liveURL: "https://covid19tracker01.netlify.app/",
  //   codeURL: "https://github.com/jubayerweb/covid19tracker",
  //   tech: [
  //     { id: 1, data: "React" },
  //     { id: 2, data: "ChartJS" },
  //     { id: 3, data: "API" },
  //     { id: 4, data: "Hooks" },
  //   ],
  // },
  // {
  //   id: 4,
  //   image: projec6,
  //   title: "Chat Application",
  //   desc: "This is a react js chat application with firebase authentication which is built with ChatEngine. So you can login with facebook or google account. You can create a room and add friends to chat each other. Enjoy!",
  //   liveURL: "https://chatscape.netlify.app/",
  //   codeURL: "https://github.com/jubayerweb/chatscape",
  //   tech: [
  //     { id: 1, data: "React" },
  //     { id: 2, data: "React Router" },
  //     { id: 3, data: "ChatEngine" },
  //     { id: 4, data: "Authentication" },
  //   ],
  // },

  // {
  //   id: 4,
  //   image: projec2,
  //   title: "Reading Cafe",
  //   desc: "A full-stack web app, where you can buy books. Admin can add product, update and delete product form UI. User’s can not order products without signing with google. Technology used react for forntend.",
  //   liveURL: "https://thereadingcafe.netlify.app/",
  //   codeURL: "https://github.com/jubayerweb/reading-cafe",
  //   tech: [
  //     { id: 1, data: "React" },
  //     { id: 2, data: "Router" },
  //     { id: 3, data: "NodeJS" },
  //     { id: 4, data: "MongoDB" },
  //     { id: 5, data: "Express" },
  //     { id: 6, data: "Firebase" },
  //     { id: 7, data: "Axios" },
  //   ],
  // },
];

const Projects = () => {
  return (
    <section className="project-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="pb-5">Some of My Projects</h2>
          </div>
        </div>
        <div className="row">
          <div className="project-card">
            {projects.map((project) => (
              <ProjectsCard key={project.id} project={project}></ProjectsCard>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
